import React from 'react'
import Svg from './Svg'
export const SvgUser = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M15.787 15.983c-1.096.839-2.386 1.327-3.787 1.327-1.401 0-2.691-.488-3.787-1.327C3.443 16.962 0 19.73 0 23h24c0-3.27-3.443-6.038-8.213-7.017zM7.066 8.75C7.066 5.022 9.275 2 12 2s4.934 3.022 4.934 6.75S14.725 15.5 12 15.5s-4.934-3.022-4.934-6.75z" />
  </Svg>
))
SvgUser.isIcon = true
export default SvgUser
